export default function ExitIcon(props) {
	return (
		<svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M4.79052 10.7699H0.781505C0.355229 10.7699 0 10.4299 0 9.9999C0 9.5799 0.355229 9.2299 0.781505 9.2299H4.79052L4.79083 4.45C4.79083 2 6.85611 0 9.38609 0H14.4254C16.945 0 19 2 19 4.44V15.56C19 18.01 16.945 20 14.4047 20H9.37576C6.85611 20 4.79083 18.01 4.79083 15.57V10.77H11.1932L9.54099 12.37C9.23119 12.67 9.23119 13.16 9.54099 13.46C9.69588 13.61 9.90241 13.68 10.1089 13.68C10.3051 13.68 10.5117 13.61 10.6666 13.46L13.6819 10.55C13.8368 10.41 13.9194 10.21 13.9194 10C13.9194 9.8 13.8368 9.6 13.6819 9.46L10.6666 6.55C10.3568 6.25 9.85078 6.25 9.54099 6.55C9.23119 6.85 9.23119 7.34 9.54099 7.64L11.1932 9.23H4.79083L4.79052 10.7699Z"
				fill="currentColor"
			/>
		</svg>
	);
}
